import React from 'react';
import { cn } from '../../../lib/utils';

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  error?: boolean;
  allowEnterAdd?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', variant = 'default', size = 'md', error = false, ...props }, ref) => {
    const baseClasses = 'w-full rounded-md transition-colors';
    
    const variantClasses = {
      default: 'border border-gray-300 bg-white text-gray-900 placeholder:text-[#737373]',
      outline: 'border border-gray-300 bg-transparent text-gray-900 placeholder:text-[#737373]',
      ghost: 'border-0 bg-transparent text-gray-900 placeholder:text-[#737373]'
    };
    
    const sizeClasses = {
      sm: 'px-3 py-2 text-sm',
      md: 'px-4 py-3 text-sm',
      lg: 'px-4 py-4 text-base'
    };
    
    const errorClasses = error ? 'border-red-500 focus:ring-red-500' : '';
    
    return (
      <div className='relative'>
        <input
          ref={ref}
          className={cn(
            baseClasses,
            variantClasses[variant],
            sizeClasses[size],
            errorClasses,
            className,
          )}
          {...props}
        />
        {props.allowEnterAdd && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#0A0A0A] opacity-60 text-xs select-none">
            Press 'Enter ↵' to add
          </div>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
